const defaultStorageAlternatives = [
  { value: 480, label: "480 GB", cost: 0 },
  { value: 960, label: "960 GB (+250 SEK)", cost: 250 },
  { value: 1920, label: "1920 GB (+750 SEK)", cost: 750 },
];

export default {
  all: () => [
    {
      id: "X10-4",
      name: "X10-4",
      cpu: {
        value: "2 x Intel® Xeon® E5-2690 v4",
        subValue: "28 cores @ 2.60 GHz",
      },
      memory: 128,
      storage: 480,
      connection: 1,
      locations: [
        { key: "dc-fbg1", value: "Falkenberg", in_stock: true },
        { key: "dc-sto1", value: "Stockholm", in_stock: true },
      ],
      mrc: 2948,
      storageAlternatives: defaultStorageAlternatives,
      connectionAlternatives: [],
    },
    {
      id: "X11-1",
      name: "X11-1",
      cpu: {
        value: "Intel® Xeon® Gold 6132",
        subValue: "14 cores @ 2.60 GHz",
      },
      memory: 64,
      storage: 480,
      connection: 10,
      locations: [
        { key: "dc-fbg1", value: "Falkenberg", in_stock: true },
        { key: "dc-sto1", value: "Stockholm", in_stock: true },
      ],
      mrc: 2665,
      storageAlternatives: defaultStorageAlternatives,
      connectionAlternatives: [],
    },
    {
      id: "X11-3",
      name: "X11-3",
      cpu: {
        value: "2 x Intel® Xeon® Gold 6132",
        subValue: "28 cores @ 2.60 GHz",
      },
      memory: 96,
      storage: 480,
      connection: 1,
      locations: [
        { key: "dc-fbg1", value: "Falkenberg", in_stock: true },
        { key: "dc-sto1", value: "Stockholm", in_stock: true },
        { key: "dc-oul1", value: "Oulu", in_stock: true },
      ],
      mrc: 3310,
      storageAlternatives: defaultStorageAlternatives,
      connectionAlternatives: [],
    },
    {
      id: "X11-4",
      name: "X11-4",
      cpu: {
        value: "2 x Intel® Xeon® Gold 6132",
        subValue: "28 cores @ 2.60 GHz",
      },
      memory: 256,
      storage: 480,
      connection: 1,
      locations: [
        { key: "dc-fbg1", value: "Falkenberg", in_stock: true },
        { key: "dc-sto1", value: "Stockholm", in_stock: true },
      ],
      mrc: 3565,
      storageAlternatives: defaultStorageAlternatives,
      connectionAlternatives: [],
    },
    {
      id: "X11-5",
      name: "X11-5",
      cpu: {
        value: "Intel® Xeon® Gold 5218R",
        subValue: "20 cores @ 2.10 GHz",
      },
      memory: 64,
      storage: 480,
      connection: 10,
      locations: [{ key: "dc-osl1", value: "Oslo", in_stock: true }],
      mrc: 2920,
      storageAlternatives: [],
      connectionAlternatives: [],
    },
    {
      id: "X11-NVME-1",
      name: "X11-NVME-1",
      cpu: {
        value: "2 x Intel® Xeon Gold 6132",
        subValue: "28 cores @ 2.6 GHz",
      },
      memory: 128,
      storage: 960,
      connection: 10,
      commit: 1,
      locations: [
        { key: "dc-fbg1", value: "Falkenberg", in_stock: true },
        { key: "dc-sto1", value: "Stockholm", in_stock: true },
      ],
      mrc: 3685,
      storageAlternatives: [],
      connectionAlternatives: [],
    },
    {
      id: "X11-NVME-2",
      name: "X11-NVME-2",
      cpu: {
        value: "2 x Intel® Xeon Gold 6132",
        subValue: "28 cores @ 2.6 GHz",
      },
      memory: 256,
      storage: 960,
      connection: 10,
      commit: 1,
      locations: [
        { key: "dc-fbg1", value: "Falkenberg", in_stock: true },
        { key: "dc-sto1", value: "Stockholm", in_stock: false },
      ],
      mrc: 3940,
      storageAlternatives: [],
      connectionAlternatives: [],
    },
  ],
};
